module.exports = __webpack_public_path__ + "static/media/christmasTree.1a02bebb.svg";